export default {
      id: "get-it-on-google-play-usage",
      viewBox: "0 0 147 43",
      url: __webpack_public_path__ + "sprite.svg#get-it-on-google-play",
      toString: function () {
        return this.url;
      }
    }